module.exports = __webpack_public_path__ + "static/media/matt_campaign_platforms.13e82646.png";